import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageSalesforceImportList
 * @description
 * # manageSalesforceImportList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'manageSalesforceImportList',
    ($ngRedux, $rootScope, $scope, $location, $route, $timeout, $http, ENV) => {
      if (!$scope.isSuperUser) {
        $location.path('/');
      }

      $scope.processParams = () =>
        new Promise((resolve) => {
          const { salesforceImportId } = $route.current.params;
          $scope.takeAction(salesforceImportId);
          resolve(true);
        });

      $scope.takeAction = (id) => {
        if (!id) return;

        if (id === 'create-salesforce-import') {
          $scope.open(id);
        } else if (id) {
          $scope
            .getSalesforceImport($http, ENV, id)
            .then(() => {
              $scope.open(id);
            })
            .catch(() => {
              const errorModalOptions = {
                heading: 'Salesforce Import Error',
                message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
                buttons: [
                  {
                    label: 'Close',
                    href: '#',
                    clickFn: () => {
                      $rootScope.toggleErrorModal();
                      $location.path($rootScope.routes.salesforce, false);
                    },
                  },
                ],
              };
              $rootScope.toggleErrorModal(errorModalOptions);
            });
        }
      };

      $scope.open = (id) => {
        const component =
          id === 'create-salesforce-import' ? 'create-salesforce-import' : 'edit-salesforce-import';
        const closeRoute = $rootScope.previousRoute || $rootScope.routes.salesforce;
        const beforeRoute = `${$rootScope.routes.salesforce}/${id}`;
        $rootScope.openComponent({
          component: component,
          beforeRoute: beforeRoute,
          closeRoute: closeRoute,
        });
      };

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes.salesforce;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.table = {
        name: 'Manage Salesforce Imports',
        options: {
          endpoint: '/2.0/reporting-database/salesforce-files/',
          endpoint_data_key: 'salesforce-files',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: false,
          search_key: null,
          search_required: false,
        },
        actions: [
          {
            name: 'Add New Filename Schema',
            link: '#',
            onclick: () => {
              $scope.takeAction('create-salesforce-import');
            },
            order: 0,
            superuser: true,
          },
        ],
        columns: [
          {
            name: 'Filename Schema ',
            options: {
              content: '%%MM%%-%%DD%%-%%YYYY%%-{{ record.filename_schema }}.txt',
              class: 'limit-width',
            },
          },
          {
            name: 'Created',
            options: {
              content: '{{ record.created }}',
              class: '',
            },
          },
          {
            name: 'Updated',
            options: {
              content: '{{ record.updated }}',
              class: '',
            },
          },
          {
            name: 'Action',
            options: {
              content:
                '<a href="#" ng-click="takeAction(record.id)">Edit Filename Schema Entry</a>',
              class: 'td-action',
            },
          },
        ],
        filters: [],
        sort_options: {
          created: {
            state: false,
            value: '-1',
            title: 'Filename Schema Entry Created',
            order: 0,
          },
          updated: {
            state: true,
            value: '-1',
            title: 'Filename Schema Entry Updated',
            order: 1,
          },
          filename_schema: {
            state: false,
            value: '1',
            title: 'Filename Schema',
            order: 2,
          },
        },
      };

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
